import { render, staticRenderFns } from "./PendingUserForms.vue?vue&type=template&id=c7ea1cf2&scoped=true"
import script from "./PendingUserForms.vue?vue&type=script&lang=js"
export * from "./PendingUserForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ea1cf2",
  null
  
)

export default component.exports